export const carouselInicio = [
   {
      "imagen" : "videos/Junio.gif",
   },  
 
 
]